var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResidency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_9-Home",
    "data-name": "9-Home"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m21.82 30h-11.64a5 5 0 0 1 -5.18-4.76v-6.24a1 1 0 0 1 2 0v6.24a3 3 0 0 0 3.18 2.76h11.64a3 3 0 0 0 3.18-2.76v-6.24a1 1 0 0 1 2 0v6.24a5 5 0 0 1 -5.18 4.76zm7.89-13.29a1 1 0 0 0 0-1.42l-13-13a1 1 0 0 0 -1.42 0l-13 13a1 1 0 0 0 1.42 1.42l12.29-12.3 12.29 12.3a1 1 0 0 0 1.42 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidency);
export default __webpack_public_path__ + "static/media/residency.c7aaac43d4cb54c39180cf4696355d78.svg";
export { ForwardRef as ReactComponent };